<template>
    <div>
        <div class="row" v-if="session.learner1 && session.learner2">
            <div class="col-sm-6">
                
                <user :user="session.learner1"
                    :handler="openOrEditLearner1"
                    :subtitle="$t('common.learner')"
                    :vertical="!compact">
                </user>

            </div>
            <div class="col-sm-6">
                
                <user :user="session.learner2"
                    :handler="openOrEditLearner2"
                    :subtitle="$t('common.learner')"
                    :vertical="!compact">
                </user>

            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">

                <user :user="learner"
                    :handler="openOrEditLearner1or2"
                    :subtitle="$t('common.learner')"
                    :vertical="!compact">
                </user>

            </div>
        </div>
    </div>
</template>

<script>
    import User from '../../dashboard/common/User'

    export default {

        components: {
            User,
        },
        
        props: {

            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },
            
            session: {
                type: Object,
                required: true
            },

            compact: {
                type: Boolean,
                default: false
            },
        },

        computed: {

            learner() {
                return this.session.learner1
                    ? this.session.learner1
                    : this.session.learner2
            },
        },

        methods: {     

            openOrEditLearner1() {
                this.openOrEditLearner(this.session.learner1)
            },

            openOrEditLearner2() {
                this.openOrEditLearner(this.session.learner2)
            },

            openOrEditLearner1or2() {
                this.openOrEditLearner(this.learner)
            },

            openOrEditLearner(learner) {
                if (learner.state.published) {
                    this.openLearner(learner)
                } else {
                    this.editLearner(learner)
                }
            },

            openLearner(learner) {
                this.$router.push({ name: 'dashboard-learner-simulation',
                    params: { 
                        learnerId: learner.id,
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                    }
                })
            },

            editLearner(learner) {
                this.$router.push({ name: 'dashboard-learner-simulation-edit',
                    params: { 
                        learnerId: learner.id,
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                    }
                })
            }
        }
    }
</script>
